module.exports = __webpack_public_path__ + "img/z-solution-img3.5f46fd35.png";